import { Route, Routes } from 'react-router-dom';

import Header from './Header';
import Beslisboom from './Beslisboom';

// import handleidingen van map handleiding
import Cuf from './handleidingen/Cuf';
import Invoerkabels from './handleidingen/Invoerkabels';
import Israpunt from './handleidingen/Israpunt';
import Meetwaarden from './handleidingen/Meetwaarden';
import Monteurstool from './handleidingen/Monteurstool';
import Procedures from './handleidingen/Procedures';
import Sync from './handleidingen/Sync';
import IsraCard from './components/IsraCard';
import Footer from './components/Footer';


function App() {
  
  return (
    <div>
      <Header />
        <Routes>
          <Route path='/' element={<Beslisboom />} />
          <Route path='/invoerkabels' element={<Invoerkabels />} />
          <Route path='/procedures' element={<Procedures />} />
          <Route path='/cuf' element={<Cuf />} />
          <Route path='/meetwaarden' element={<Meetwaarden />} />
          <Route path='/isra' element={<Israpunt />} />
          <Route path='/sync' element={<Sync />} />
          <Route path='/monteurstool' element={<Monteurstool />} />
          <Route path='/test' element={<IsraCard />} />
        </Routes>

      <Footer />
    </div>
  );
}

export default App;
